<template>
  <el-dialog title="" :visible="ShowModal" :show-close="false" width="600px" class="ts-modal modal-image">
    <figure class="img-container"><img src="../assets/img/congrats.png" alt="Triage" /></figure>
    
    <div style="text-align:center;">
      <span class="h5">Congratulations!</span>
    
      &nbsp;&nbsp;

      <p><b>Congratulations on being offered the role <u>{{ this.$props.Info.roleTitle }}</u>.</b><br></p>
      <p>If you agree to this offer, you will become an {{ this.$props.offerType === 'Apprentice' ? 'apprentice' : 'employee' }} for <u>{{ this.$props.Info.companyName }}</u> <br>
        {{ this.$props.OfferType === 'Apprentice' ? '' : 'and will no longer be a Job Seeker.' }} </p>
      <p v-if="this.$props.OfferType !== 'Apprentice'">You will be sent an email with your new company TalentSensus login details.</p>
    </div>

    &nbsp;&nbsp;

    <el-row>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
        <button class="ts-btn ts-btn-small" style="width: 90%;margin: auto;" @click="acceptJobOffer">Accept Job Offer</button>
      </el-col>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
        <button class="ts-btn ts-btn-small ts-btn-white" style="width: 90%;margin: auto;" @click="declineJobOffer">Decline</button>
      </el-col>
      <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
        <button class="ts-btn ts-btn-small ts-btn-white" style="width: 90%;margin: auto;" @click="onCloseDialog(null)">Go Back</button>
      </el-col>
    </el-row>
    <!-- <loading 
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading :active="isLoading" :defaultMessage="'Please wait...'" :altMessage="'Please hold on for a moment while we process the data...'"/>
  </el-dialog>
</template>

<script>
import * as signalR from '@aspnet/signalr';
import TSLoading from '../components/TSLoading.vue';

export default {  
  components: {
    TSLoading
  },
  name: 'AcceptDeclineJobOffer',
  props: {
    ShowModal: {
      type: Boolean,
      default: false
    },
    Info: {
      type: Object,
      default() {
        return {};
      }
    },
    OfferType: {
      type: String,
      default: 'Apprentice' // Employee
    },
    AcceptJobOfferUrl: {
      type: String,
      default: 'apprentice/acceptApprenticeshipOffer'
    },
    DeclineJobOfferUrl: {
      type: String,
      default: 'apprentice/declineApprenticeshipOffer'
    }
  },
  created(){
    //create signalR connection
    this.huburl = process.env.VUE_APP_MESSAGE_BASE_URI;
    this.connection = new signalR.HubConnectionBuilder().withUrl(this.huburl, { 
      transport: signalR.HttpTransportType.WebSockets | signalR.HttpTransportType.LongPolling,
      'content-type': 'application/json',
      accessTokenFactory: () => localStorage.getItem('token') 
    }).build();

    this.connection.start().catch(function (err) {
      return console.error(err.toString());
    });
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    onCloseDialog() {
      this.$emit('accept-job-offer-modal-closed');
    },
    declineJobOffer() {
      this.isLoading = true;
      this.$store.dispatch(this.$props.DeclineJobOfferUrl, this.$props.Info)
        .then((res) => {
          // this.connection.invoke("SendMessageToAdmin", "Employee Added").catch(function (err) {
          //   return console.error(err.toString());
          // });
          this.$emit('decline-offer-success', res);
          this.isLoading = false;
          this.ShowModal = false;
        }).catch((res) => {
          this.isLoading = false;
          this.$message.error(res.error);
        });
    },
    acceptJobOffer() {
      this.isLoading = true;
      this.$store.dispatch(this.$props.AcceptJobOfferUrl, this.$props.Info)
        .then((res) => {
          // this.connection.invoke("SendMessageToAdmin", "Employee Added").catch(function(err){
          //   return console.error(err.toString());
          // });
          this.$emit('accept-offer-success', res);
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          this.$message.error(res.error);
        });
    }
  }
};
</script>